import { Command } from "commander";

export const program = new Command("fre");